import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, subtitle, testId }) => (
  <section className="relative overflow-hidden bg-[#0A1633] text-white" data-testid={testId}>
    <div
      className="pointer-events-none absolute inset-0 opacity-[0.07]"
      style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, #93C5FD 1px, transparent 0)",
        backgroundSize: "28px 28px",
      }}
    />
    <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-blue-300"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, delay: 0.08 }}
        className="mt-4 max-w-3xl text-4xl font-extrabold tracking-tight sm:text-5xl"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.16 }}
          className="mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
